/**
 * Navigation for the app build (REACT_APP_BUILD_FOR=app), which swaps the
 * sidebar for bottom tabs plus a "More" sheet. The first TAB_LIMIT entries of
 * TAB_CANDIDATES the admin may open become tabs; every other permitted entry
 * lands in the More sheet, so nothing the sidebar offers is lost.
 *
 * `countKey` maps to a live badge count from useAdminCounts (see AppShell).
 */

// Tabs beside the centre "+" button (new manual booking). Without that
// permission there is no button and one more tab fits.
export const TAB_LIMIT = 3;
export const TAB_LIMIT_NO_FAB = 4;

// Opens the calendar's manual booking panel (see bookings/Calendar.jsx).
export const FAB = { path: '/admin/booking-calendar?new=1', permission: 'bookings.manual-create' };

export const TAB_CANDIDATES = [
    // `icon` is the outline shown normally, `activeIcon` the filled one for the selected tab.
    { path: '/admin/dashboard',        title: 'Home',     icon: 'bi bi-house-door',     activeIcon: 'bi bi-house-door-fill',     permission: 'dashboard.view'    },
    { path: '/admin/bookings',         title: 'Bookings', icon: 'bi bi-calendar-check', activeIcon: 'bi bi-calendar-check-fill', permission: 'bookings.index',   countKey: 'bookings' },
    { path: '/admin/users',            title: 'Clients',  icon: 'bi bi-people',         activeIcon: 'bi bi-people-fill',         permission: 'users.index'       },
    { path: '/admin/booking-calendar', title: 'Calendar', icon: 'bi bi-calendar3',      activeIcon: 'bi bi-calendar-fill',       permission: 'bookings.calendar' },
    { path: '/admin/transactions',     title: 'Payments', icon: 'bi bi-credit-card',    activeIcon: 'bi bi-credit-card-fill',    permission: 'transactions.index' },
];

export const MORE_GROUPS = [
    {
        title: 'Bookings & Payments',
        items: [
            { path: '/admin/booking-calendar', title: 'Booking Calendar', icon: 'bi bi-calendar3',        permission: 'bookings.calendar'  },
            { path: '/admin/transactions',     title: 'Transactions',     icon: 'bi bi-credit-card-fill', permission: 'transactions.index' },
            { path: '/admin/promo-codes',      title: 'Promo Codes',      icon: 'bi bi-ticket-perforated-fill', permission: 'promo-codes.index' },
        ],
    },
    {
        title: 'Memberships',
        items: [
            { path: '/admin/membership-plans',                       title: 'Plans',                 icon: 'bi bi-card-checklist', permission: 'membership-plans.index' },
            { path: '/admin/membership-plans/subscribers',           title: 'Subscribers',           icon: 'bi bi-person-badge',   permission: 'membership-plans.subscribers',           countKey: 'subscribers'   },
            { path: '/admin/membership-plans/cancellation-requests', title: 'Cancellation Requests', icon: 'bi bi-x-octagon',      permission: 'membership-plans.cancellation-requests', countKey: 'cancellations' },
        ],
    },
    {
        title: 'Rooms & Services',
        items: [
            { path: '/admin/rooms',    title: 'Rooms',    icon: 'bi bi-door-open-fill', permission: 'rooms.index'    },
            { path: '/admin/services', title: 'Services', icon: 'bi bi-snow2',          permission: 'services.index' },
        ],
    },
    {
        title: 'Communication',
        items: [
            { path: '/admin/broadcasts',    title: 'Send Notifications', icon: 'bi bi-send-fill',            permission: 'broadcasts.index'    },
            { path: '/admin/notifications', title: 'My Notifications',   icon: 'bi bi-bell-fill',            permission: 'notifications.index' },
            { path: '/admin/pages',         title: 'Pages',              icon: 'bi bi-file-earmark-text-fill', permission: 'pages.index'       },
        ],
    },
    {
        title: 'Team',
        items: [
            { path: '/admin/system-users', title: 'System Users',        icon: 'bi bi-people-fill',   permission: 'system-users.index' },
            { path: '/admin/roles',        title: 'Roles & Permissions', icon: 'bi bi-shield-check',  permission: 'roles.index'        },
            { path: '/admin/attendance',   title: 'Attendance Logs',     icon: 'bi bi-clock-history', permission: 'attendance.index'   },
        ],
    },
    {
        title: 'Settings',
        items: [
            { path: '/admin/settings', title: 'Settings', icon: 'bi bi-gear-fill',   permission: 'settings.view' },
            { path: '/admin/account',  title: 'Account',  icon: 'bi bi-person-fill', permission: 'account.view'  },
        ],
    },
];

// Title for the top bar: the most specific menu entry the path falls under.
export const findMenuItem = (pathname, items) => {
    const path = pathname.replace(/\/$/, '');
    return items
        .filter((item) => path === item.path || path.startsWith(item.path + '/'))
        .sort((a, b) => b.path.length - a.path.length)[0] || null;
};
